module.exports = __webpack_public_path__ + "static/media/rs.e0acf82f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/rs.svg
// module id = 235
// module chunks = 0